/* eslint-disable import/no-unresolved */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */

import { useState, useEffect, useRef, useMemo } from "react";
import { Badge, Button, Combobox, Input } from "@repo/ui";
import { Link } from "react-router-dom";
import { CirclePlus, CircleX } from "lucide-react";
import { Paths } from "routes/paths";
import { HasPermission } from "utils/helper";
import { useUser } from "hooks/use-user";
import { useLookupCashCenters } from "services/lookups-mutations";

export default function VehiclesFilterBarV2({ getList }) {
  const [filters, setFilters] = useState({});
  const [selectedCashCenter, setSelectedCashCenter] = useState("");
  const [firstLoad, setFirstLoad] = useState(true);
  const [filter, setFilter] = useState(null);
  const filterTimeout = useRef(null);
  const { mutate: getCashCenters, data: cashCentersList } =
    useLookupCashCenters();
  const user = useUser();
  useEffect(() => {
    getCashCenters();
  }, []);
  useEffect(() => {
    if (filter !== null) {
      filterTimeout.current = setTimeout(() => {
        getList(filter || "", selectedCashCenter || "");
        handleAddFilter("filter", filter, "Search");
        clearTimeout(filterTimeout.current);
        filterTimeout.current = null;
      }, 1000);
    }
    return () => {
      if (filterTimeout.current) {
        clearTimeout(filterTimeout.current);
        filterTimeout.current = null;
      }
    };
  }, [filter]);
  useEffect(() => {
    if (!firstLoad) {
      getList(filter || "", selectedCashCenter || "");
    } else {
      setFirstLoad(false);
    }
  }, [selectedCashCenter]);

  const handleClearFilter = (key) => {
    const updatedFilter = { ...filters };
    delete updatedFilter[key];
    if (key === "cashCenter") {
      setSelectedCashCenter("");
    } else if (key === "filter") {
      setFilter("");
    }
    setFilters({ ...updatedFilter });
  };
  const handleAddFilter = (key, value, name) => {
    if (value === "") {
      handleClearFilter(key);
      return;
    }
    const updatedFilter = { ...filters };

    updatedFilter[key] = `${name}: ${value}`;
    setFilters({ ...updatedFilter });
  };
  const clearAllFilters = () => {
    setFilters({});
    setSelectedCashCenter("");
    setFilter("");
  };

  const canAdd = useMemo(() => {
    return HasPermission(user, "Vehicle", "Add");
  }, [user]);
  return (
    <>
      <div className="flex mb-3 gap-1">
        <div className="min-w-[15%] ">
          <Combobox
            placeholder="Select Cash Center"
            data={[
              { label: "Select Cash Center", value: "" },
              ...((cashCentersList?.data || []).map((elm) => ({
                label: elm.name,
                value: elm.cashCenterId,
              })) || []),
            ]}
            value={selectedCashCenter}
            setValue={(value) => {
              setSelectedCashCenter(value);
              let name = "";
              if (value !== "") {
                name = cashCentersList?.data.filter(
                  (elm) => elm.cashCenterId === value
                )[0].name;
              }
              handleAddFilter("cashCenter", name, "Cash Center");
            }}
          />
        </div>
        <div className="w-full">
          <Input
            value={filter}
            placeholder="Search"
            title="Search"
            onChange={(e) => {
              setFilter(e.target.value);
            }}
          />
        </div>
        {canAdd ? (
          <Button
            variant="secondary"
            className="flex-1 flex flex-row justify-end gap-0"
            style={{ padding: 0 }}
          >
            <Link to={Paths.addVehicles}>
              <Button variant="secondary" className="flex flex-row gap-2">
                <CirclePlus />
                Create Vehicle
              </Button>
            </Link>
          </Button>
        ) : (
          <></>
        )}
      </div>
      <div className="flex mb-3 gap-2 flex-wrap items-end">
        {Object.entries(filters).map(([key, value]) => (
          <Badge
            variant="secondary"
            className="gap-3 pr-1 cursor-pointer"
            key={key}
          >
            {value}
            <CircleX
              onClick={() => {
                handleClearFilter(key);
              }}
            />
          </Badge>
        ))}
        {Object.keys(filters).length > 0 ? (
          <Badge variant="secondary" className="gap-3 pr-1 cursor-pointer">
            Clear All
            <CircleX
              onClick={() => {
                clearAllFilters();
              }}
            />
          </Badge>
        ) : (
          <></>
        )}
      </div>
    </>
  );
}
